import MyWalletPage from 'pages/my/wallet/index';

export default MyWalletPage;
